import React, { useCallback, useEffect, useState } from 'react';

import { useAxios } from '../../../hooks/Axios';
import { useRelations } from '../../../hooks/Relations';
import { IIncommingNode, IMessageComplete } from '../../../hooks/Messages';
import Loader from './Loader';
import MessageError from './MessageError';
import MessageResend from './MessageResend';
import MessageWrapper from './MessageWrapper';
import { textPreprocessor } from './common';
import AdditionalInformation from './AdditionalInformation';
import { ApiNodeBody, Node } from '../../../api/models';

export interface IIncommingNodeProps extends IIncommingNode {
    message: IMessageComplete
    scrollToBottom: () => void
}

interface IIncommingNodeState {
    loading: boolean,
    error?: boolean
    answer?: string
}

const DEFAULT_STATE: IIncommingNodeState = {
    loading: true
};

function IncommingNode({ nodeId, message, scrollToBottom }: IIncommingNodeProps) {
    const additionalInformation = AdditionalInformation();
    const [state, setState] = useState<IIncommingNodeState>(DEFAULT_STATE);
    const { setId } = useRelations();
    const axios = useAxios();

    //nacteni informaci ze serveru
    const call = useCallback(
        async () => {
            setState({ loading: true });

            try {
                const response = await additionalInformation(
                    await axios.post<Node>('node', { id: nodeId } as ApiNodeBody)
                );

                setState({
                    loading: false,
                    answer: response.data.answer
                });
                setId(nodeId);
            }
            catch (error) {
                console.error(error);
                setState({
                    loading: false,
                    error: true
                });
            };
            scrollToBottom();//po nacteni dat odscrolluj chat na posledni zpravu
        },
        [additionalInformation, axios, nodeId, scrollToBottom, setId]
    );

    //dotahovani informaci k uzlu pri namounteni komponenty
    useEffect(
        () => {
            call();
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    return (
        <MessageWrapper
            key={state.answer}
            direction={message.direction}
            info={state.error && <MessageResend resend={call} />}>
            {
                state.loading ?
                    <Loader /> :
                    state.error ?
                        <MessageError /> :
                        <h3>{textPreprocessor(state.answer)}</h3>
            }
        </MessageWrapper>
    );
}

export default IncommingNode;
